import { useOptionSerial } from 'NavigationProvider';
import i18nEl from 'i18n_el';
import i18nEng from 'i18n_eng';
import React, { useMemo } from 'react';
import QuestionnaireAnswers from 'components/QuestionnaireAnswers';
import { useNutrigenetixDataReport } from 'models/kits';
import { I18nextProvider } from 'react-i18next';
import { blueColor } from './NutriGenetix';

const NutriGenetixQuestionnaireAnswers = () => {
  const { serial } = useOptionSerial('nutriGenetix');
  const { locale } = useNutrigenetixDataReport(serial);

  const i18nProv = useMemo(() => {
    if ('el-GR' === locale) {
      return i18nEl;
    }

    return i18nEng;
  }, [ locale ]);

  return (
    <I18nextProvider i18n={ i18nProv }>
      <QuestionnaireAnswers serial={ serial } color={ blueColor } />
    </I18nextProvider>
  );
};

export default NutriGenetixQuestionnaireAnswers;
